<div class="container">

  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner loading" [style.display]="blockedUi ? 'block' : 'none'"></i>
  </div>
  }

  <div class="grid">

    <div class="col-12">
      <span class="title">{{ 'TRANSLATE.MANUAL.CONTRACT' | translate }}</span>
    </div>

    <div class="col-12 search-filters-wrapper">
      <p-accordion>
        <p-accordionTab header="Novo" [selected]="true">
          <div class="novo-content-area">
            <div class="ui-fluid filters-grid">

              <div class="filter-item">
                <label class="filtro" for="countryManual">{{ 'TRANSLATE.TWO.POINTS.COUNTRY' | translate
                  }}</label><br />
                <p-dropdown id="countryManual" [options]="countries" [(ngModel)]="country"
                  placeholder="{{ 'TRANSLATE.SELECT' | translate }}" (onChange)="countryChange($event)"
                  [style]="{'minWidth':'100%'}">
                  <ng-template pTemplate="item" let-item>
                    {{item?.label | translate}}
                  </ng-template>
                  <ng-template pTemplate="selectedItem" let-item>
                    {{item?.label | translate}}
                  </ng-template>
                </p-dropdown>
              </div>

              <div class="filter-item">
                <label class="filtro" for="saleTypeManual">{{ 'TRANSLATE.TWO.POINTS.SALE.TYPE' | translate
                  }}</label><br />
                <p-dropdown id="saleTypeManual" [options]="salesTypeFords" [(ngModel)]="salesTypeFord"
                  placeholder="{{ 'TRANSLATE.SELECT' | translate }}" optionLabel="description"
                  [style]="{'minWidth':'100%'}"></p-dropdown>
              </div>

              <div class="filter-item">
                <label class="filtro" for="gesbContractManual">{{ 'TRANSLATE.TWO.POINTS.GESB.CONTRACT' |
                  translate }}</label><br />
                <p-dropdown id="gesbContractManual" [options]="contractGesb" [(ngModel)]="isContractGesb"
                  placeholder="{{ 'TRANSLATE.SELECT' | translate }}" [style]="{'minWidth':'100%'}">
                  <ng-template pTemplate="item" let-item>
                    {{item?.label | translate}}
                  </ng-template>
                  <ng-template pTemplate="selectedItem" let-item>
                    {{item?.label | translate}}
                  </ng-template>
                </p-dropdown>
              </div>

              <div class="filter-item">
                <label class="filtro" for="productActiveManual">{{ 'TRANSLATE.ID.PRODUCT.CODE' | translate
                  }}</label><br />
                <p-dropdown id="productActiveManual" [options]="productActiveCountries"
                  placeholder="{{ 'TRANSLATE.SELECT' | translate }}" [(ngModel)]="productActive"
                  (onChange)="productChange($event)" optionLabel="name" [style]="{'minWidth':'100%'}"></p-dropdown>
              </div>

              <div class="filter-item full-row">
                <label class="filtro" for="coverageCategoryManual">{{
                  'TRANSLATE.TWO.POINTS.COVERAGE.DESCRIPTION' | translate }}</label><br />
                <p-dropdown id="coverageCategoryManual" [options]="coverageCategorys"
                  placeholder="{{ 'TRANSLATE.SELECT' | translate }}" [(ngModel)]="coverageCategory"
                  optionLabel="description" [style]="{'minWidth':'100%'}"></p-dropdown>
              </div>

              <div class="filter-item">
                <label class="filtro" for="monthsManual">{{ 'TRANSLATE.TWO.POINTS.MONTHS' | translate
                  }}</label><br />
                <input pInputText id="monthsManual" disabled="true" [(ngModel)]="coverageCategory.term" type="text"
                  placeholder="Meses" style="width: 100%" />
              </div>

              <div class="filter-item">
                <label class="filtro" for="distanceKmManual">{{ 'TRANSLATE.TWO.POINTS.DISTANCE.KM' |
                  translate }}</label><br />
                <input pInputText id="distanceKmManual" disabled="true" [(ngModel)]="coverageCategory.distance"
                  type="text" placeholder="Distância km" style="width: 100%" />
              </div>

              <div class="filter-item">
                <label class="filtro" for="visitManual">{{ 'TRANSLATE.TWO.POINTS.VISIT' | translate
                  }}</label><br />
                <input pInputText id="visitManual" disabled="true" [(ngModel)]="coverageCategory.visit" type="text"
                  placeholder="Visitas" style="width: 100%" />
              </div>

              <div class="filter-item">
                <label class="filtro" for="initialVisitManual">{{ 'TRANSLATE.TWO.POINTS.INITIAL.VISIT' |
                  translate }}</label><br />
                <input pInputText id="initialVisitManual" disabled="true" [(ngModel)]="coverageCategory.startVisit"
                  type="text" placeholder="Visita Inicial" style="width: 100%" />
              </div>

              <div class="filter-item full-row">
                <label class="filtro" for="vinsManual">{{ 'TRANSLATE.TWO.POINTS.VINS' | translate
                  }}</label><br />
                <textarea pInputTextarea id="vinsManual" [(ngModel)]="vins" (blur)="vins=vins.trim()" maxlength="3400"
                  autoResize="false" class="textarea"></textarea>
              </div>

              <div class="filter-item full-row filter-hint-row">
                <small class="field-hint">
                  {{ 'TRANSLATE.TWO.POINTS.OBS.SEPARATE.VINS.BY.ENTER' | translate }}
                </small>
              </div>

              @if (duplicateVinsInputMessage) {
              <div class="filter-item full-row">
                <p-message severity="warn" [text]="duplicateVinsInputMessage">
                </p-message>
              </div>
              }
              @if (invalidLengthVinsInputMessage) {
              <div class="filter-item full-row">
                <p-message severity="warn" [text]="invalidLengthVinsInputMessage">
                </p-message>
              </div>
              }
              @if (notFoundVinsValidationMessage) {
              <div class="filter-item full-row">
                <p-message severity="warn" [text]="notFoundVinsValidationMessage">
                </p-message>
              </div>
              }
            </div>

            <div class="filter-actions-row validation-actions-row">
              <button pButton type="button" class="undo-action-button app-clean-button" (click)="buttonCleanVins()"
                [disabled]="blockedUi">
                <i class="pi pi-trash" aria-hidden="true"></i>
                <span class="undo-action-button-label">{{ 'TRANSLATE.BNT.CLEAR' | translate }}</span>
              </button>
              <button pButton type="button" class="action-button app-primary-button" (click)="validateVinsButton()"
                [disabled]="blockedUi" [attr.aria-busy]="isValidatingVins">
                @if (!isValidatingVins) {
                <i class="pi pi-check" aria-hidden="true"></i>
                }
                @if (isValidatingVins) {
                <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
                }
                <span class="action-button-label">{{ (isValidatingVins ? 'TRANSLATE.IN.PROCESSING' :
                  'TRANSLATE.VALIDATE.VINS') | translate }}</span>
              </button>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>

      <div class="content-card validation-table-section">
        <label class="filtro" for="validationVinsManual">{{ 'TRANSLATE.TWO.POINTS.VALIDATION.VINS' |
          translate }}</label><br />
        <p-table id="validationVinsManual" #tabela [value]="vinSaveAndVectors" [paginator]="true" [rows]="10"
          [totalRecords]="vinSaveAndVectors.length"
          styleClass="app-table app-table--condensed app-table--sticky-action">
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="table-empty-message">
                {{ 'TRANSLATE.NO.VINS.FOUND' | translate }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 150px !important;">{{ 'TRANSLATE.VIN' | translate }}</th>
              <th style="width: 100px !important;">{{ 'TRANSLATE.WSD' | translate }}</th>
              <th style="width: 100px !important;">{{ 'TRANSLATE.WERS' | translate }}</th>
              <th style="width: 100px !important;">{{ 'TRANSLATE.MODEL.YEAR' | translate }}
              </th>
              <th style="width: 80px !important;">{{ 'TRANSLATE.TMA' | translate }}</th>
              <th style="width: 60px !important;">{{ 'TRANSLATE.ACTIONS' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr class="table-row-center">
              <td style="width: 150px !important;">
                {{ rowData.vin }}
              </td>
              <td style="width: 100px !important;">
                {{ rowData.warrantyStartDate | date:'dd/MM/yyyy'}}
              </td>
              <td style="width: 100px !important;">
                {{ rowData.wersCode }}
              </td>
              <td style="width: 100px !important;">
                {{ rowData.modelYear}}
              </td>
              <td style="width: 80px !important;">
                {{ rowData.tma}}
              </td>
              <td style="width: 60px !important;">
                <button pButton class="row-icon-button" [icon]="blockedUi ? 'pi pi-spin pi-spinner' : 'pi pi-trash'"
                  [pTooltip]="blockedUi ? ('TRANSLATE.IN.PROCESSING' | translate) : ('TRANSLATE.DELETE' | translate)"
                  tooltipPosition="top"
                  [attr.aria-label]="blockedUi ? ('TRANSLATE.IN.PROCESSING' | translate) : ('TRANSLATE.DELETE' | translate)"
                  (click)="buttonRemoveVin(rowData)" [disabled]="blockedUi"></button>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div class="filter-actions-row section-actions-row novo-secondary-actions">
          <button pButton type="button" class="undo-action-button app-clean-button"
            (click)="buttonCleanValidationVins()" [disabled]="blockedUi">
            <i class="pi pi-trash" aria-hidden="true"></i>
            <span class="undo-action-button-label">{{ 'TRANSLATE.CLEAN' | translate }}</span>
          </button>
          <button pButton type="button" class="action-button app-primary-button"
            (click)="buttonValidationContractVins()" [disabled]="blockedUi">
            <i class="pi pi-plus" aria-hidden="true"></i>
            <span class="action-button-label">{{ 'TRANSLATE.ADD.VINS.CONTRACT.LIST' | translate }}</span>
          </button>
        </div>
      </div>

      <div class="content-card contracts-table-section">
        <label class="filtro" for="contractsManual">
          {{ 'TRANSLATE.TWO.POINTS.LIST.CREATING.NEW.CONTRACTS' | translate }}
        </label><br />
        <p-table id="contractsManual" #tabela [value]="contractsManual" [paginator]="true" [rows]="10"
          [totalRecords]="contractsManual.length" styleClass="app-table app-table--wide app-table--sticky-action">
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="10" class="table-empty-message">
                {{ 'TRANSLATE.NO.CONTRACTS.FOUND' | translate }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 30px"></th>
              <th style="width: 100px !important;">{{ 'TRANSLATE.N.CONTRACT' | translate }}</th>
              <th style="width: 150px !important;">{{ 'TRANSLATE.VIN' | translate }}</th>
              <th style="width: 100px !important;">{{ 'TRANSLATE.SALE.DATE.TABLE' | translate }}</th>
              <th style="width: 100px !important;">{{ 'TRANSLATE.START.DATE.TABLE' | translate }}</th>
              <th style="width: 100px !important;">{{ 'TRANSLATE.END.DATE.TABLE' | translate }}</th>
              <th class="contracts-product-col">{{ 'TRANSLATE.PRODUCT' | translate }}</th>
              <th style="width: 420px !important;">{{ 'TRANSLATE.COVERAGE' | translate }}</th>
              <th style="width: 180px !important;">{{ 'TRANSLATE.STATUS' | translate }}</th>
              <th style="width: 60px !important;">{{ 'TRANSLATE.ACTIONS' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr class="table-row-center">
              <td style="width: 30px ">
                @if (rowData.hasError === true) {
                <span class="row-status-icon row-status-error" [pTooltip]="rowData.message" tooltipPosition="top">
                  <span class="pi pi-exclamation-triangle"></span>
                </span>
                }
                @if (rowData.hasError === false) {
                <span class="row-status-icon row-status-success" [pTooltip]="rowData.message" tooltipPosition="top">
                  <span class="pi pi-check"></span>
                </span>
                }
              </td>
              <td style="width: 100px !important;">
                {{ rowData.contractId}}
              </td>
              <td style="width: 150px !important;">
                {{ rowData.vin }}
              </td>
              <td style="width: 100px !important;">
                {{ rowData.saleDate | date:'dd/MM/yyyy'}}
              </td>
              <td style="width: 100px !important;">
                {{ rowData.startDate | date:'dd/MM/yyyy'}}
              </td>
              <td style="width: 100px !important;">
                {{ rowData.endDate | date:'dd/MM/yyyy'}}
              </td>
              <td class="contracts-product-col" [title]="rowData.product.productName">
                <span class="app-cell-clamp-2">{{ rowData.product.productName }}</span>
              </td>
              <td style="width: 420px !important;" [title]="rowData.product.coverageName">
                <span class="app-cell-clamp-2">{{ rowData.product.coverageName }}</span>
              </td>
              <td style="width: 180px !important;">
                @if (rowData.hasError === true) {
                <span class="contract-status-message contract-status-error">{{ rowData.message }}</span>
                }
                @if (rowData.hasError === false) {
                <span class="contract-status-message contract-status-success">{{ rowData.message }}</span>
                }
              </td>
              <td style="width: 60px !important;">
                <button pButton class="row-icon-button" [icon]="blockedUi ? 'pi pi-spin pi-spinner' : 'pi pi-trash'"
                  [pTooltip]="blockedUi ? ('TRANSLATE.IN.PROCESSING' | translate) : ('TRANSLATE.DELETE' | translate)"
                  tooltipPosition="top"
                  [attr.aria-label]="blockedUi ? ('TRANSLATE.IN.PROCESSING' | translate) : ('TRANSLATE.DELETE' | translate)"
                  (click)="buttonRemoveVinContract(rowData)" [disabled]="blockedUi"></button>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div class="filter-actions-row section-actions-row contracts-actions-row">
          <button pButton type="button" class="undo-action-button app-clean-button" (click)="buttonCleanContract()"
            [disabled]="blockedUi">
            <i class="pi pi-trash" aria-hidden="true"></i>
            <span class="undo-action-button-label">{{ 'TRANSLATE.BNT.CLEAR' | translate }}</span>
          </button>
          <button type="button" pButton class="action-button app-primary-button" (click)="buttonCreateContract()"
            [disabled]="blockedUi" [attr.aria-busy]="isCreatingContracts">
            @if (!isCreatingContracts) {
            <i class="pi pi-book" aria-hidden="true"></i>
            }
            @if (isCreatingContracts) {
            <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
            }
            <span class="action-button-label">{{ (isCreatingContracts ? 'TRANSLATE.IN.PROCESSING' :
              'TRANSLATE.CREATE.NEW.CONTRACTS') | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>